import { ArrowRight } from "lucide-react";
import { site } from "../../lib/siteConfig";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-brand-bg"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/5771259/pexels-photo-5771259.jpeg"
          alt="Skyline di Milano"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg via-brand-bg/95 to-brand-bg/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-bg via-transparent to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-28 sm:pt-28 sm:pb-36 lg:pt-36 lg:pb-44">
        <div className="max-w-3xl">
          <p
            data-testid="hero-eyebrow"
            className="divider-ornament anim-fade-up"
          >
            Consulenza Strategica sulla Rendita Immobiliare
          </p>

          <h1
            data-testid="hero-headline"
            className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl lg:text-7xl font-black tracking-tight text-brand-ink mt-8 anim-fade-up anim-delay-1"
          >
            Sei sicuro che stai davvero
            <span className="italic font-normal"> guadagnando </span>
            con il tuo immobile?
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-8 max-w-2xl text-lg sm:text-xl leading-relaxed text-brand-muted anim-fade-up anim-delay-2"
          >
            In Italia c'è stato il <span className="text-brand-ink font-medium">boom degli affitti brevi</span>, ma ora il mercato sta cambiando: la domanda è sempre più alta sulle locazioni transitorie e sulle locazioni tradizionali.
            La maggior parte dei proprietari non ha una visione globale e pensa che stia guadagnando — ma la rendita viene erosa da commissioni OTA, pulizie, manutenzioni, property manager, utenze.
            Rivolgersi a me significa avere un <span className="text-brand-ink font-medium">consulente immobiliare</span> che ti spiega i numeri reali, ti dice se stai davvero guadagnando e individua la soluzione più redditizia per il tuo immobile.
          </p>

          <div
            data-testid="hero-cta-group"
            className="mt-12 flex flex-wrap items-center gap-3 sm:gap-4 anim-fade-up anim-delay-3"
          >
            <a
              href={site.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-brand-ink text-white px-8 py-4 rounded-sm font-medium hover:bg-brand-inkHover transition-all shadow-sm"
            >
              Prenota una call gratuita di 30 min
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <h2
            data-testid="hero-transitori-title"
            className="mt-14 font-display text-2xl sm:text-3xl font-bold text-brand-ink anim-fade-up anim-delay-4"
          >
            Scopri gli <span className="italic font-normal">affitti transitori</span>
            <span className="ml-1 align-top text-brand-muted text-base">*</span>
          </h2>

          <div
            data-testid="hero-trust"
            className="mt-6 grid grid-cols-3 gap-6 sm:gap-10 max-w-xl anim-fade-up anim-delay-4"
          >
            {[
              { k: "10%", v: "Imposta cedolare" },
              { k: "18 mesi", v: "Durata massima" },
              { k: "IMU", v: "Sconto applicato" },
            ].map((s) => (
              <div key={s.v} className="border-l border-brand-beigeDark pl-4">
                <div className="font-display text-2xl sm:text-3xl text-brand-ink font-bold">{s.k}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-brand-muted">{s.v}</div>
              </div>
            ))}
          </div>

          <p className="mt-5 text-xs italic text-brand-muted anim-fade-up anim-delay-4">
            *Solo per i contratti a canone concordato.
          </p>
        </div>
      </div>
    </section>
  );
};
